import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_editor_field = _resolveComponent("editor-field")
  const _component_legacy_rich_text_field = _resolveComponent("legacy-rich-text-field")

  return ($options.hasBlockRichTextEditor)
    ? (_openBlock(), _createBlock(_component_editor_field, _mergeProps({ key: 0 }, _ctx.$attrs, {
        "model-value": $props.modelValue,
        "toolbar-controls": $props.editorControls,
        "output-format": $props.outputFormat,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:modelValue', $event)))
      }), {
        "field-description": _withCtx(() => [
          _renderSlot(_ctx.$slots, "field-description")
        ]),
        _: 3 /* FORWARDED */
      }, 16 /* FULL_PROPS */, ["model-value", "toolbar-controls", "output-format"]))
    : (_openBlock(), _createBlock(_component_legacy_rich_text_field, _mergeProps({ key: 1 }, _ctx.$attrs, {
        "model-value": $props.modelValue,
        "toolbar-controls": $options.legacyToolbarControls,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:modelValue', $event)))
      }), {
        "field-description": _withCtx(() => [
          _renderSlot(_ctx.$slots, "field-description")
        ]),
        _: 3 /* FORWARDED */
      }, 16 /* FULL_PROPS */, ["model-value", "toolbar-controls"]))
}